import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var t = /*#__PURE__*/function () {
  function t(_t, s) {
    _classCallCheck(this, t);

    this.S = !!_t, this.ve = s || [];
  }

  _createClass(t, [{
    key: "V",
    value: function V(_t2) {
      var _this$ve;

      this.S = this.S && _t2.S, (_this$ve = this.ve).push.apply(_this$ve, _toConsumableArray(_t2.ve));
    }
  }]);

  return t;
}();

export { t as default };